import { atom } from "jotai";
export var editorStateAtom = atom(null);